<script lang="ts">
  /** In preview mode: a PREVIEW badge, and a LIVE label over the corner monitor. */
  import { PREVIEW_MONITOR } from '../../shared/messages';
</script>

<div class="badge" aria-hidden="true">Preview</div>
<div
  class="live-label"
  aria-hidden="true"
  style:left={`${PREVIEW_MONITOR.left * 100}%`}
  style:top={`${PREVIEW_MONITOR.top * 100}%`}
>
  Live
</div>

<style>
  .badge,
  .live-label {
    position: absolute;
    z-index: 12;
    pointer-events: none;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }
  .badge {
    top: 14px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(75, 227, 160, 0.9);
    color: #04140c;
  }
  .live-label {
    margin: 6px;
    background: rgba(235, 31, 46, 0.92);
    color: #fff;
  }
</style>
